import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=210d5f74&"
import script from "./VideoComponent.vue?vue&type=script&lang=js&"
export * from "./VideoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('210d5f74')) {
      api.createRecord('210d5f74', component.options)
    } else {
      api.reload('210d5f74', component.options)
    }
    module.hot.accept("./VideoComponent.vue?vue&type=template&id=210d5f74&", function () {
      api.rerender('210d5f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/VideoComponent.vue"
export default component.exports